import React, { useState, useRef, useEffect } from 'react';

const AutocompleteInput = ({ value, onChange, suggestions = [], placeholder = '', className = '', required = false }) => {
  const [open, setOpen] = useState(false);
  const [filtered, setFiltered] = useState([]);
  const ref = useRef(null);

  useEffect(() => {
    if (value.length < 1) {
      setFiltered([]);
      setOpen(false);
      return;
    }
    const matches = suggestions.filter(s =>
      s.toLowerCase().includes(value.toLowerCase()) && s !== value
    ).slice(0, 6);
    setFiltered(matches);
    setOpen(matches.length > 0);
  }, [value, suggestions]);

  // Close on outside click
  useEffect(() => {
    const handler = (e) => {
      if (ref.current && !ref.current.contains(e.target)) {
        setOpen(false);
      }
    };
    document.addEventListener('mousedown', handler);
    return () => document.removeEventListener('mousedown', handler);
  }, []);

  const select = (s) => {
    onChange(s);
    setOpen(false);
  };

  return (
    <div ref={ref} className="relative">
      <input
        type="text"
        required={required}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        className={className}
        onFocus={() => filtered.length > 0 && setOpen(true)}
        autoComplete="off"
      />
      {open && (
        <ul className="absolute z-50 w-full mt-1 bg-white border border-neutral-200 rounded-xl shadow-xl overflow-hidden max-h-48 overflow-y-auto">
          {filtered.map((s, i) => (
            <li
              key={i}
              onMouseDown={() => select(s)}
              className="px-3 py-2 text-sm text-neutral-700 hover:bg-primary-50 hover:text-primary-700 cursor-pointer transition-colors"
            >
              {s}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default AutocompleteInput;
